import { type FC } from 'react'
import { Alert } from 'react-bootstrap'
import styles from './EmailEditor.module.scss'
import { issueLines, issueSummary } from './validate/issueSummary'
import { type StateError } from './validate/validateState'

export interface EmailIssuesProps {
  errors: StateError[]
}

export const EmailIssues: FC<EmailIssuesProps> = ({ errors }) => {
  const summary = issueSummary(errors)
  return summary ? (
    <Alert variant='danger' className='mb-0 d-flex flex-column zocks-gap-0.375 zocks-border-0.75'>
      <span className='paragraph-medium fw-600'>{summary.title}</span>
      <ul className='list-unstyled mb-0 ps-1 d-flex flex-column gap-2 paragraph-small fw-normal'>
        {issueLines(errors).map((line) => (
          <li key={line.text} className='d-flex align-items-center gap-2'>
            {line.text}
            {line.numbers.length ? (
              <span className='d-flex gap-1'>
                {line.numbers.map((number) => (
                  <span key={number} className={styles.issueMarker}>
                    {number}
                  </span>
                ))}
              </span>
            ) : null}
          </li>
        ))}
      </ul>
    </Alert>
  ) : null
}
